var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2332 2.01059C16.6099 2.284 15.9458 2.46522 15.2534 2.55322C15.9657 2.12792 16.5094 1.45959 16.765 0.654036C16.1008 1.05 15.3676 1.3297 14.5861 1.48578C13.9555 0.814309 13.0567 0.398438 12.0762 0.398438C10.1739 0.398438 8.64238 1.9425 8.64238 3.8354C8.64238 4.10776 8.66543 4.36964 8.72199 4.61896C5.86537 4.47963 3.33766 3.11051 1.63961 1.02486C1.34316 1.5392 1.16927 2.12792 1.16927 2.76168C1.16927 3.95168 1.78208 5.00654 2.69553 5.61726C2.14347 5.60678 1.6019 5.44651 1.14308 5.19405C1.14308 5.20453 1.14308 5.21815 1.14308 5.23176C1.14308 6.90153 2.33413 8.28847 3.896 8.60797C3.61631 8.68444 3.31148 8.7211 2.99512 8.7211C2.77514 8.7211 2.55306 8.70853 2.3446 8.66244C2.7898 10.0232 4.05313 11.0236 5.5553 11.0561C4.38625 11.9706 2.90189 12.5216 1.29497 12.5216C1.01318 12.5216 0.74292 12.509 0.472656 12.4744C1.99472 13.456 3.79858 14.0164 5.74385 14.0164C12.0668 14.0164 15.5236 8.77872 15.5236 4.2387C15.5236 4.08681 15.5184 3.94015 15.5111 3.79455C16.193 3.31058 16.766 2.70616 17.2332 2.01059Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.f6feea45c0d6b296f047642a94233155.svg";
export { ForwardRef as ReactComponent };